import { TModals, TModalStyleVariantsKey } from './TModals';

// RETURNS ALL STYLES RELATED TO MODAL STYLE VARIANT
export const getModalStyleVariantValues = (theme: TModals, variant: TModalStyleVariantsKey) => ({
  ...theme.variants[variant],
});

export default getModalStyleVariantValues;
